import round from 'lodash/round';

export const isNumeric = (value: any) => {
  return typeof value === 'number' || !isNaN(parseFloat(value));
};

export const toRound = (val: number, decimalPLace: number) =>
  +(Number.isInteger(val) ? val : val.toFixed(decimalPLace));

export const minuteToHours = (minutes: number) => round(minutes / 60, 2);
